import React from 'react';
import FormWidget from '../../form/FormWidget';
import { useI18n } from '../../i18n/I18n';

export default ({
    imageId,
    onSaveImage = () => {}
}: {
    imageId: string;
    onSaveImage?: (_name: string, ref: string) => void;
}) => {
    return (
        <FormWidget
            name={'imageReference'}
            component="Image"
            dimensions={[160, 160]}
            label={useI18n(imageId ? 'edit.photo' : 'add.photo')}
            onChange={onSaveImage}
            save
            buttonSx={{
                textTransform: 'none',
                pb: 0
            }}
        />
    );
};
